export const SET_PROSPECT_FORM_VALUES = 'SET_PROSPECT_FORM_VALUES';
export const CLEAR_PROSPECT_FORM_VALUES = 'CLEAR_PROSPECT_FORM_VALUES';
